<template>
    <section class="sub_page_con wrap_1120 mypage_my_info">
        <div class="join sign_form" v-if="state.isConfirm">
            <ul>
                <li class="_blocked">
                    <label for="user_id" class="form_li_tit">아이디</label>
                    <input id="user_id" type="text" v-model="state.info.id" disabled />
                </li>
                <!-- <li class=" ">
                    <label for="user_id" class="form_li_tit">본인인증</label>
                    <button class="blue_btn">본인인증</button>
                    <button class="blue_btn _blocked" disabled>본인인증완료</button>
                    <p class="p_warn">*본인인증을 완료해주세요.</p>
                </li> -->
                <template v-if="!user.userInfo.isAdmin && !user.userInfo.snsGubun">
                    <li class="">
                        <label for="user_pw" class="form_li_tit">비밀번호</label>
                        <input id="user_pw" type="password" v-model="state.pw" placeholder="비밀번호를 입력하세요" />
                        <p class="p_info" v-if="!state.pwIsPossible">비밀번호는 문자, 숫자, 특수문자의 조합으로 8자 이상 입력해주세요.</p>
                    </li>
                    <li class="">
                        <label for="user_pw_chk" class="form_li_tit">비밀번호 확인</label>
                        <input id="user_pw_chk" type="password" v-model="state.re_pw" placeholder="비밀번호 확인" />
                        <p class="p_warn" v-if="!state.pwReCheck">*비밀번호가 일치하지 않습니다. 다시 입력해주세요.</p>
                    </li>
                </template>
                <li class="_blocked">
                    <label for="" class="form_li_tit">이름</label>
                    <input id="name" type="text" v-model="state.info.name" disabled />
                </li>
                <template v-if="!user.userInfo.isAdmin">
                    <li class="">
                        <label for="" class="form_li_tit">닉네임</label>
                        <input id="nickname" type="text" v-model="state.data.nickname" placeholder="닉네임을 입력하세요" />
                    </li>
                    <li class="_blocked">
                        <label for="" class="form_li_tit">생년월일</label>
                        <input id="birthday" type="text" v-model="state.data.birth" disabled />
                    </li>
                    <li class="checkbox_wrap _blocked">
                        <span class="form_li_tit">성별</span>
                        <label for="female">
                            <input id="female" name="gender" type="radio" value="F" v-model="state.data.gender" checked disabled />
                            <em></em>
                            <span>여자</span>
                        </label>
                        <label for="male">
                            <input id="male" name="gender" type="radio" value="M" v-model="state.data.gender" disabled />
                            <em></em>
                            <span>남자</span>
                        </label>
                        <label for="gender_etc">
                            <input id="gender_etc" name="gender" type="radio" value="E" v-model="state.data.gender" disabled />
                            <em></em>
                            <span>기타</span>
                        </label>
                    </li>
                    <li class="mail_wrap _blocked">
                        <label for="mail_01" class="form_li_tit _blocked">E-mail</label>
                        <input id="mail_01" type="text" placeholder="" v-model="state.email" disabled />
                        <em>@</em>
                        <input id="mail_02" type="text" placeholder="" v-model="state.domain" disabled />
                        <!-- <div class="select_tab_box">
                        <div class="selected_tab">
                            <span>직접입력</span>
                        </div>
                        <div class="tab_option">
                            <button>gmail.com</button>
                            <button>naver.com</button>
                            <button>daum.net</button>
                            <button class="self">직접입력</button>
                        </div>
                    </div>
                    <button class="blue_btn">중복확인</button> -->
                    </li>
                    <li class="phone_wrap">
                        <label for="user_ph1" class="form_li_tit">전화번호</label>
                        <input id="user_ph1" disabled type="text" v-model="state.phone1" />
                        <em>-</em>
                        <input id="user_ph2" disabled type="text" v-model="state.phone2" />
                        <em>-</em>
                        <input id="user_ph3" disabled type="text" v-model="state.phone3" />
                    </li>
                    <li class="add_wrap">
                        <label for="" class="form_li_tit">주소</label>
                        <input id="zip_code" v-model="state.data.zipCode" type="text" class="code _blocked" placeholder="우편번호" disabled />
                        <button class="blue_btn" @click="searchAddress">검색</button>
                        <input id="address" v-model="state.data.addr" type="text" class="main_add _blocked" placeholder="기본주소" disabled />
                        <input id="address_detail" v-model="state.data.addrDetail" type="text" placeholder="상세주소" />
                    </li>
                </template>
            </ul>
            <!-- <div class="btn_wrap _default left_right_btn _1_2">
                    <div class="left">
                        <button class="common_btn _gray w_180 ">
                            회원탈퇴
                        </button>
                    </div>
                    <div class="right ">
                        <button class="common_btn _gray w_180">
                            취소
                        </button>
                        <button class="common_btn w_180">
                            정보수정
                        </button>
                    </div>
                </div> -->

            <div class="btn_wrap _default _center" v-if="!user.userInfo.isAdmin">
                <button class="common_btn w_180" @click="modify">정보수정</button>
            </div>
        </div>
    </section>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        userStore,
        globalStore,
        reactive,
        watch,
        apiService,
        onMounted,
        Header,
        Footer,
        types,
        CommonUtils,
        ModalDefault,
        getMessageByCode,
        router,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault },
        setup() {
            const global = globalStore();
            const user = userStore();

            const state = reactive({
                data: {} as types.ResMemberVOForApi,
                info: {} as types.memberVO,
                email: "" as string,
                domain: "" as string,

                phone1: "" as string,
                phone2: "" as string,
                phone3: "" as string,

                pw: "" as string,
                re_pw: "",
                isPossible: false,
                pwIsPossible: false,
                pwReCheck: false,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isConfirm: false as boolean,
            });

            const form_state = reactive({
                zip_code: "",
                address: "",
            });

            onMounted(() => {
                global.$reset();

                if (!user.userInfo.snsGubun) {
                    state.isConfirm = false;

                    state.modalTab = 3;
                    state.modalTitle = "안내";
                    state.modalContent = "비밀번호를 입력해 주세요.";
                    state.isShowModal = true;
                } else {
                    state.isConfirm = true;
                    getMyInfo();
                }
            });

            watch(
                () => state.pw,
                () => {
                    if (CommonUtils.regexForPassword.test(state.pw)) {
                        state.pwIsPossible = true;
                    } else {
                        state.pwIsPossible = false;
                    }
                },
            );

            watch(
                () => [state.pw, state.re_pw],
                () => {
                    if (state.pw === state.re_pw) {
                        state.pwReCheck = true;
                        state.pw = state.pw;
                    } else {
                        state.pwReCheck = false;
                    }
                },
            );

            const init = () => {
                state.isConfirm = true;
                state.isShowModal = false;

                getMyInfo();
            };

            const isPw = async (pw: string) => {
                try {
                    const param = {
                        pw: pw,
                    } as types.ReqConfirmPwForMyPage;

                    const res: types.BaseResponse = await apiService.mypage.pwConfirm(param);

                    if (res.returnCode === 0) {
                        init();
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("데이터 불러오기 실패", err);
                }
            };

            const getMyInfo = async () => {
                try {
                    const res: types.ResUserInfo = await apiService.mypage.me();
                    if (res.returnCode === 0) {
                        state.data = res.data;
                        state.info = res.data.memberVO;

                        if (!user.userInfo.isAdmin) {
                            state.email = res.data.email.split("@")[0];
                            state.domain = res.data.email.split("@")[1];

                            const phone = res.data.phone.replaceAll("-", "");

                            state.phone1 = phone.slice(0, 3);
                            state.phone2 = phone.slice(3, 7);
                            state.phone3 = phone.slice(7, 11);
                        }
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("데이터 불러오기 실패", err);
                }
            };

            const searchAddress = async () => {
                new window.daum.Postcode({
                    oncomplete: (data: any) => {
                        state.data.zipCode = data.zonecode;
                        state.data.addr = data.address;
                    },
                }).open();
            };

            const modify = async () => {
                try {
                    if (checkValue()) {
                        const param: types.ReqUserForModify = {
                            pw: state.pw,
                            zipCode: state.data.zipCode,
                            address: state.data.addr,
                            addressDetail: state.data.addrDetail,
                            nickName: state.data.nickname,
                        };

                        let res: types.BaseResponse = await apiService.mypage.modify(param);
                        if (res.returnCode === 0) {
                            state.modalTab = 8;
                            state.modalTitle = "알림";
                            state.modalContent = "수정 되었습니다.";
                            state.isShowModal = true;

                            state.pw = "";
                            state.re_pw = "";
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = 8;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                } catch (err) {
                    console.error("데이터 불러오기 실패", err);
                }
            };

            const checkValue = () => {
                let msg = "";
                if (state.pw && (!state.pwIsPossible || !state.pwReCheck)) msg = "비밀번호 형식이 맞지 않거나 일치하지 않습니다.";
                else if (state.data.nickname?.trim() === "" || !state.data.nickname) msg = "닉네임을 입력해주세요.";
                if (msg) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = msg;
                    state.isShowModal = true;
                    return false;
                } else {
                    return true;
                }
            };
            const closeModal = () => {
                state.isShowModal = false;
                if (state.modalTab === 3 || state.modalTab !== 8) router.replace("/");
            };

            const callBackModal = async (param: any) => {
                if (param.action === "checkPw") {
                    isPw(param.pw);
                }
            };

            return { global, user, state, searchAddress, form_state, modify, closeModal, callBackModal };
        },
    };
</script>
<style scoped>
    .add_wrap input._blocked {
        background-color: #f5f5f5;
    }
</style>
